import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Button } from '@bringg/react-components';
import { useWebhooksApiStore, Webhook } from '@bringg-frontend/webhooks-api-internal-stores';

import WebhooksEdit from '../webhooks-edit/webhooks-edit';

const WebhooksHeaders: React.FC = () => {
	const { t } = useTranslation();
	const { webhooksAppStore } = useWebhooksApiStore();
	const [shouldModalOpen, setShouldModalOpen] = useState(false);

	return (
		<div className="webhooks-add-webhook">
			<Button type="primary" size="middle" className="button" onClick={() => setShouldModalOpen(true)}>
				{t('WEBHOOK_APP.HEADER.ADD_WEBHOOK_BUTTON', { defaultValue: 'Add Webhook' })}
			</Button>
			{shouldModalOpen ? (
				<WebhooksEdit
					closeEdit={() => setShouldModalOpen(false)}
					webhook={
						new Webhook({ urls: [''], newStructure: true, enableFlexibleWebhook: true }, webhooksAppStore)
					}
					isNew={true}
				/>
			) : (
				''
			)}
		</div>
	);
};

export default WebhooksHeaders;
